export const MatchDayStatusResultValues = {
  partial: 'PARTIAL',
  complete: 'COMPLETE',
};

export const MatchDayStatuses = {
  players: 'players',
  captain: 'captain',
  lineup: 'lineup',
  subs: 'subs',
  staff: 'staff',
  physician: 'physician',
};

export const KitMatrixEquipmentRoles = {
  HomePlayer: 'home_player',
  HomeGoalkeeper: 'home_goalkeeper',
  Referee: 'referee',
  AwayPlayer: 'away_player',
  AwayGoalkeeper: 'away_goalkeeper',
};

export const KitMatrixEquipment = {
  jersey: 'jersey',
  shorts: 'shorts',
  socks: 'socks',
};

export const PlayerTypes = {
  player: 'player',
  goalkeeper: 'goalkeeper',
  referee: 'referee',
};

export const FALLBACK_DASH = '-';
